/**
 * Report type ids that the frontend references
 * 
 * The full set of available report types is resolved dynamically from the backend
 * (`getAccountReportTypes`) and Sanity CMS, so this is NOT an exhaustive list. 
 * Only add an id here when code needs to reference it by name.
 */
export const ReportType = {
  addresses: 'addresses',
  billingHistory: 'billingHistory',
  companyBalances: 'companyBalances',
  defiTransactions: 'defiTransactions',
  feeAssignment: 'feeAssignment',
  fundRecon: 'fundRecon',
  generic: 'generic',
  genericGift: 'genericGift',
  genericIncome: 'genericIncome',
  genericTaxAccounting: 'genericTaxAccounting',
  ofxTransactions: 'ofxTransactions',
  table: 'table',
  tax8283: 'tax8283',
  tax8949: 'tax8949',
  taxact: 'taxact',
  trtax: 'trtax',
  turbotax: 'turbotax',
}

export default ReportType;
